import {
  ArrowsInLineHorizontal,
  CaretDoubleDown,
  Equals,
  Gear,
  GreaterThan,
  GreaterThanOrEqual,
  LessThan,
  LessThanOrEqual,
  MagnifyingGlass,
  MemberOf,
  NotEquals,
  NotMemberOf,
  NumberZero,
  Path,
  SubsetProperOf,
  NotSubsetOf,
  ClockCounterClockwise,
} from '@phosphor-icons/react';
import { ReactComponent as All } from '@/assets/icon/all-operator.svg';
import { ReactComponent as Any } from '@/assets/icon/any-operator.svg';
import { ReactComponent as IsNotNull } from '@/assets/icon/is-not-null-operator.svg';
import { ReactComponent as StartsWith } from '@/assets/icon/starts-with-operator.svg';
import { ReactComponent as EndsWith } from '@/assets/icon/ends-with-operator.svg';

export const onboarding = [
  {
    id: 0,
    icon: Path,
    descr: 'Understand definitions configured',
  },
  {
    id: 1,
    icon: Gear,
    descr: 'Understand the drill-down configured for each definitions',
  },
  {
    id: 2,
    icon: MagnifyingGlass,
    descr: 'Search for reports using business language ',
  },
  {
    id: 3,
    icon: CaretDoubleDown,
    descr: 'Perform incremental drill-down on reports',
  },
];

export const OPERATORS = {
  eq: {
    id: 'eq',
    label: 'equals',
    icon: Equals,
    belongsTo: ['number', 'date', 'boolean'],
  },
  ne: {
    id: 'ne',
    label: 'not equals',
    icon: NotEquals,
    belongsTo: ['number', 'boolean'],
  },
  gte: {
    id: 'gte',
    label: 'greater or equal',
    icon: GreaterThanOrEqual,
    belongsTo: ['number'],
  },
  lte: {
    id: 'lte',
    label: 'less or equal',
    icon: LessThanOrEqual,
    belongsTo: ['number'],
  },
  gt: {
    id: 'gt',
    label: 'greater than',
    icon: GreaterThan,
    belongsTo: ['number'],
  },
  lt: {
    id: 'lt',
    label: 'less than',
    icon: LessThan,
    belongsTo: ['number'],
  },
  any: {
    id: 'any',
    label: 'any',
    icon: Any,
    belongsTo: ['multienum'],
  },
  all: {
    id: 'all',
    label: 'all',
    icon: All,
    belongsTo: ['multienum'],
  },
  in: {
    id: 'in',
    label: 'in',
    icon: MemberOf,
    belongsTo: ['number', 'string', 'enum'],
  },
  not_in: {
    id: 'not_in',
    label: 'not in',
    icon: NotMemberOf,
    belongsTo: ['multienum', 'number', 'string', 'enum'],
  },
  contains: {
    id: 'contains',
    label: 'contains',
    icon: SubsetProperOf,
    belongsTo: ['string', 'enum'],
  },
  not_contains: {
    id: 'not_contains',
    label: 'does not contains',
    icon: NotSubsetOf,
    belongsTo: ['string', 'enum'],
  },
  starts_with: {
    id: 'starts_with',
    label: 'starts with',
    icon: StartsWith,
    belongsTo: ['string', 'enum'],
  },
  ends_with: {
    id: 'ends_with',
    label: 'ends with',
    icon: EndsWith,
    belongsTo: ['string', 'enum'],
  },
  empty: {
    id: 'empty',
    label: 'is null',
    icon: NumberZero,
    belongsTo: ['multienum', 'string', 'number', 'enum', 'boolean'],
  },
  not_empty: {
    id: 'not_empty',
    label: 'is not null',
    icon: IsNotNull,
    belongsTo: ['multienum', 'string', 'number', 'enum', 'boolean'],
  },
  range: {
    id: 'range',
    label: 'between',
    icon: ArrowsInLineHorizontal,
    belongsTo: ['number'],
  },
  year: {
    id: 'year',
    label: 'in',
    icon: Equals,
    belongsTo: [],
  },
  year_quarter: {
    id: 'year_quarter',
    label: 'in',
    icon: Equals,
    belongsTo: [],
  },
  year_month: {
    id: 'year_month',
    label: 'in',
    icon: Equals,
    belongsTo: [],
  },
  last: {
    id: 'last',
    label: 'in',
    icon: Equals,
    belongsTo: [],
  },
  this: {
    id: 'this',
    label: 'in',
    icon: Equals,
    belongsTo: [],
  },
  next: {
    id: 'next',
    label: 'in',
    icon: Equals,
    belongsTo: [],
  },
  before: {
    id: 'before',
    label: 'in',
    icon: Equals,
    belongsTo: [],
  },
  after: {
    id: 'after',
    label: 'in',
    icon: Equals,
    belongsTo: [],
  },
  today: {
    id: 'today',
    label: 'in',
    icon: Equals,
    belongsTo: [],
  },
};

export const MESSAGE_TYPES = {
  SUGGESTED_DRILLDOWNS: 'suggested-drilldowns',
  TEXT: 'text',
  CLARIFICATION: 'clarification',
  HTML: 'html',
  LOADING: 'loading',
  GET_HELP: 'get-help',
  DRILLDOWN_WELCOME: 'drilldown-welcome',
  REQUEST_ASSISTANCE: 'request-assistance',
  NO_DRILLDOWNS: 'no-drilldowns',
  RATINGS: 'ratings',
  ADD_COLUMN_WELCOME: 'add-column-welcome',
  SUGGESTED_COLUMNS: 'suggested-columns',
  NO_COLUMNS: 'no-columns',
  EXPLORE_COLUMNS: 'explore-columns',
};

export const VIEW_MAX_DRILLDOWNS = 4;

export const SENDER = {
  SYSTEM: 'system',
  USER: 'user',
};

export const FEEDBACKS = [
  "Definitions isn't available",
  'Need different drill-down options',
  'Operation not supported',
  'Something else',
];

export const RATINGS = [
  'Data seems incorrect',
  'Data not current',
  'Report loading too slowly',
  'Report format needs improvement',
  'Important data missing',
  'Something else',
];

export const BOOLEAN_CLARIFICATION_VALUES = {
  eq: [
    { label: 'Yes', value: 1 },
    { label: 'No', value: 0 },
  ],
  empty: [
    { label: 'is empty', value: true },
    { label: 'is not empty', value: false },
  ],
};

export const GUIDELINES_URLS = {
  REPORTS_SEARCH:
    'https://help.petavue.com/en/articles/10335558-guidelines-for-search#h_4412982042',
  DRILLDOWN_SEARCH:
    'https://help.petavue.com/en/articles/10335558-guidelines-for-search#h_7775281283',
  ADD_COLUMN_SEARCH:
    'https://help.petavue.com/en/articles/10335558-guidelines-for-search#h_0a8fb7e602',
  CHARTS_SEARCH:
    'https://help.petavue.com/en/articles/10335558-guidelines-for-search#h_c6ca21f876',
};

export const TOP_NAV_MENUS = [
  {
    id: 0,
    icon: Path,
    name: 'Definitions',
  },
  {
    id: 1,
    name: 'Reports History',
    icon: ClockCounterClockwise,
  },
];
